<!-- 
  @desc 综合查询
-->
<template>
  <el-container class="main_panel" direction="vertical">
    <el-col :span="24"> <title-bar :titleBar="'综合查询'"></title-bar></el-col>
    <el-container direction="vertical" class="content_panel">
      <el-row :gutter="16" class="search_panel">
        <el-col :span="4">
          <el-select placeholder="年度" size="small">
            <el-option :value="test"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select placeholder="审批类型" size="small">
            <el-option :value="test"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select placeholder="项目" size="small">
            <el-option :value="test"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select placeholder="地点" size="small">
            <el-option :value="test"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="名称" size="small"></el-input>
        </el-col>
        <el-col :span="4" align="left">
          <el-button type="primary" size="small" icon="el-icon-search">查询</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" class="table" height="500" stripe border size="small">
        <el-table-column label="年度" width="100" align="center"></el-table-column>
        <el-table-column label="赛事类型" width="150" align="center"></el-table-column>
        <el-table-column label="赛事名称" align="left"></el-table-column>
        <el-table-column label="项目" width="150" align="center"></el-table-column>
        <el-table-column label="比赛日期" width="250" align="left"></el-table-column>
        <el-table-column label="地点" width="180" align="left"></el-table-column>
        <el-table-column label="操作" fixed="right" :width="tableEventWth.opt" align="left"></el-table-column>
      </el-table>
      <Page />
    </el-container>
  </el-container>
</template>
<script>
import TitleBar from "@/components/public/TitleBar.vue";
import Page from "@/components/public/Page.vue";
export default {
  components: {
    TitleBar,
    Page
  },
  data() {
    return {
      /**表格数据 */
      tableData: []
    };
  }
};
</script>
